import * as types from "../types/contentRatings";

const initialState = {
  isLoading: false,
  isPartialLoading: false,
  isError: null,
  certifications: {},
  certificate: {},
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.IS_LOADING:
      return { ...state, isLoading: payload };
    case types.IS_PARTIAL_LOADING:
      return { ...state, isPartialLoading: payload };
    case types.IS_ERROR:
      return { ...state, isError: payload };
    case types.CERTIFICATIONS:
      return { ...state, certifications: payload };
    case types.CERTIFICATE:
      return { ...state, certificate: payload };
    default:
      return state;
  }
}
